// Libs
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Context
import { useComponentsPool } from '../../../../ComponentsPool';
import { useFootBar } from '../../../footbar/FootBarContext';
import { useFormState } from '../../../layout/forms/api/useFormState';

// Helper
import { concatTickets, enableDeleteOnTicket } from '../../helper';
// Actions
import { editTicket } from '../../actions';
import { getGroupList } from '../../../groups/actions';
import { removeParamFromURL } from '../../../core/helper';

export default () => {
    const { Component } = useComponentsPool();
    const dispatch = useDispatch();
    const tickets = useSelector(state => state.tickets);
    const footBar = useFootBar();
    const workspaceSettings = useSelector(state => state.workspace.settings);
    const currentUser = useSelector(state => state.users.currentUser);
    const { formState } = useFormState();
    const selectedTickets = footBar.getList();

    const switchButtonCallback = () => {
        return dispatch(editTicket(formState?.id, formState)).then(() => {
            dispatch(getGroupList());
            // Clean the ticket key from the page URL
            const cleanedURL = removeParamFromURL(window.location.href, 'key');
            window.history.replaceState({}, '', cleanedURL);
        });
    };

    // Calculate footbar buttons based on deletion permissions
    const footbarButtons = useMemo(() => {
        // Check if all selected tickets can be deleted by the current user
        const canDeleteTickets =
            currentUser &&
            selectedTickets &&
            selectedTickets.length > 0 &&
            selectedTickets.every(ticket => enableDeleteOnTicket(currentUser, ticket, workspaceSettings));

        return [
            canDeleteTickets ? (
                <Component
                    key={'1'}
                    componentName={'DeleteTicketFootbarButton'}
                />
            ) : null
        ];
    }, [workspaceSettings, currentUser, selectedTickets, Component]);

    return (
        <Component
            componentName={'Footbar'}
            actionButtons={footbarButtons}
            modal={'TicketDetailsPopup'}
            resourceList={concatTickets(tickets.list)}
            switchButtonCallback={switchButtonCallback}
            resourceType={'Ticket'}
            locale={'tickets'}
        />
    );
};
